var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 77,
    rx: 15,
    fill: "url(#paint0_linear_344_154)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3333 34H37.3333C35.4924 34 34 35.4924 34 37.3333V52.3333C34 54.1743 35.4924 55.6667 37.3333 55.6667H52.3333C54.1743 55.6667 55.6667 54.1743 55.6667 52.3333V37.3333C55.6667 35.4924 54.1743 34 52.3333 34Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3334 44.0002H25.6667C24.7827 44.0002 23.9348 43.649 23.3097 43.0239C22.6846 42.3987 22.3334 41.5509 22.3334 40.6668V25.6668C22.3334 24.7828 22.6846 23.9349 23.3097 23.3098C23.9348 22.6847 24.7827 22.3335 25.6667 22.3335H40.6667C41.5508 22.3335 42.3986 22.6847 43.0237 23.3098C43.6489 23.9349 44 24.7828 44 25.6668V27.3335",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_154",
    x1: 72,
    y1: 74,
    x2: 5,
    y2: 5.50001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F039A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B348FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.809f5915326e291266506b6fd7e45dec.svg";
export { ForwardRef as ReactComponent };